import { Routes } from '@angular/router';
import { DatabetComponent } from './databet/databet.component';
import { HealthComponent } from './health/health.component';  
import { LiwComponent } from './liw/liw.component';

export const routes: Routes = [
    { path: 'databet', component: DatabetComponent },
    { path: 'health', component: HealthComponent },
    { path: 'live-instant-win', component: LiwComponent }
];
